"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const convex_1 = __importDefault(require("@turf/convex"));
const react_maps_1 = require("@yanzi/react-maps");
const react_1 = require("react");
const useSiteFloorPlan_1 = require("../../hooks/useSiteFloorPlan");
function SiteMap(_a) {
    var { floorLevel } = _a, props = __rest(_a, ["floorLevel"]);
    const { featureCollections, rotation } = useSiteFloorPlan_1.useSiteFloorPlan(floorLevel);
    const boundingPolygon = react_1.useMemo(() => {
        var _a;
        const features = featureCollections.reduce((features, featureCollection) => [...features, ...featureCollection.features], []);
        try {
            return (_a = convex_1.default({ type: 'FeatureCollection', features })) !== null && _a !== void 0 ? _a : null;
        }
        catch (_b) {
            return null;
        }
    }, [featureCollections]);
    return (jsx_runtime_1.jsxs(react_maps_1.Map, Object.assign({ rotation: rotation }, props, { children: [boundingPolygon && (jsx_runtime_1.jsx(react_maps_1.GeoJSONFeature, { feature: boundingPolygon, opacity: 0, zIndex: -2000, autoCenter: true }, void 0)), props.children] }), void 0));
}
exports.SiteMap = SiteMap;
//# sourceMappingURL=index.js.map